/*
 * @Author: your name
 * @Date: 2021-07-13 14:49:11
 * @LastEditTime: 2022-10-24 13:37:27
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\router\center-business\index.js
 */
import user from './user'; // 用户管理
import channel from './channel'; // 渠道管理
import goods from './goods'; // 商品管理
import stock from './stock'; // 库存管理
// import order from './order'; // 订单管理
import csgOrder from './csgOrder'; // 订单管理
import after from './after'; // 售后管理

// #ifndef OPEN-SOURCE
import logistics from './logistics'; // 物流管理
// import finance from './finance'; // 财务管理
import report from './report'; // 报表管理
import BIreport from './BIreport'; // BI报表管理
import WMSWave from './WMSWave'; // WMS 智显大屏
import Workforce from './Workforce'; // 用工管理
import quotationCenter from './quotationCenter'; // 报价
import customer from './customer'; // 客户
// import marketing from './marketing'; // 营销管理
// #endif

import purchase from './purchase'; // 采购管理
// import quotation from './quotation'; // 报价管理
import billing from './billing'; // 账单管理
import help from './help'; // 用户手册
// import payment from './payment'; // 账期管理
import platform from './platform'; // 平台管理
import inbound from './inbound'; // 入库管理-csg
import workorder from './workorder';
import tools from './tools';

/* ******************************  暂时不显示  *******************************/
// import log from './log'; // 日志管理
// import worksheet from './worksheet'; // 工单管理
// import strategy from './strategy';

// 修改以下数组，需同时修改 src\layout\components\Sidebar\HoverItem.vue 99:TODO
const BUSINESS_CENTER_ROUTER = [
  user,
  channel,
  goods,
  stock,
  // #ifndef OPEN-SOURCE
  logistics,
  // #endif
  // order,
  csgOrder,
  // #ifndef OPEN-SOURCE
  // #endif
  after,
  // #ifndef OPEN-SOURCE
  // finance,
  // #endif
  // log,
  // #ifndef OPEN-SOURCE
  // marketing,
  // #endif
  // #ifndef OPEN-SOURCE
  report,
  BIreport,
  WMSWave,
  Workforce,
  quotationCenter,
  customer,
  // #endif
  // worksheet,

  // strategy,
  purchase,

  // quotation,
  billing,
  help,
  // payment,
  platform,
  inbound,
  workorder,
  tools,
];
// 按可见子菜单数量 从小到大 排序一下……
// BUSINESS_CENTER_ROUTER.sort(function(a, b) {
//   return (
//     a.children.filter(e => e.hidden != true).length -
//     b.children.filter(e => e.hidden != true).length
//   );
// });

export default BUSINESS_CENTER_ROUTER;
